var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-list"},_vm._l((_vm.navList),function(item){return _c('div',{key:`item-${item.id}`,staticClass:"catalog-list__item"},[_c('catalog-list-item',{attrs:{"category":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }